import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default () => {
  return (
      <>
        <Header/>
        <main>
            <div class="breadcrumb__area bg-color-2 p-relative" style={{backgroundImage:`url('assets/img/resources/page-title-4.jpg')`}}>
                <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumb__wrapper p-relative">
                            <h2 class="breadcrumb__title">Services</h2>
                            <div class="breadcrumb__menu">
                            <nav>
                                <ul>
                                    <li><span><a href="index.html">Home</a></span></li>
                                    <li><span>Services</span></li>
                                </ul>
                            </nav>
                            </div>                
                        </div>
                    </div>
                </div>
                </div>
            </div>

            <section class="choose-section sec-padding">
                <div class="mkt-container">
                    <div class="row g-4">
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon-2">
                                <img src="assets/img/service-icon/01.svg" alt="img"/>
                                </div>
                                <div class="content">
                                    <h4><a href="#">Commercial Property Leasing</a></h4>
                                    <p>We specialize in identifying, negotiating, and finalizing lease agreements for retail, office, and industrial spaces across strategic locations.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon-2">
                                    <img src="assets/img/service-icon/02.svg" alt="img"/>
                                </div>
                                <div class="content">
                                    <h4><a href="services.html">End-to-End Project Execution</a></h4>
                                    <p>From shell to show-ready — we handle civil work, interior fit-outs, branding, and utility setup to deliver a fully functional commercial space.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon-2">
                                    <img src="assets/img/service-icon/03.svg" alt="img"/>
                                </div>
                                <div class="content">
                                    <h4><a href="services.html">Tenant Acquisition & Brand Onboarding</a></h4>
                                    <p>We bring trusted brands to prime commercial locations. Our portfolio includes retail, F&B, co-working spaces, and educational ventures.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon-2">
                                    <img src="assets/img/service-icon/04.svg" alt="img"/>
                                </div>
                                <div class="content">
                                    <h4><a href="services.html">Space Planning & Customization</a></h4>
                                    <p>We collaborate with tenants to tailor layouts, amenities, and designs that suit business needs while optimizing functionality and aesthetics.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="choose-box">
                                <div class="icon-2">
                                <img src="assets/img/service-icon/01.svg" alt="img"/>
                                </div>
                                <div class="content">
                                    <h4><a href="services.html">Property Marketing & Advisory</a></h4>
                                    <p>We assist property owners and developers with market analysis, feasibility studies, and promotion strategies to attract the right clients.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Footer/>
      </>
  );
};
